import * as axios from './Axios'

export const ride_details = bid => axios.get(`ride/details/${bid}`);

export const locate_vehicle = (bookingId,vehicleId) => axios.get(`bookings/${bookingId}/vehicles/${vehicleId}/locate`);


